import { googleLogout } from "@react-oauth/google";
import { useState, useEffect, createContext, useContext } from "react";
import { STORAGE_KEYS, clearAllStorage } from "utils/storage.utils";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const storedUserData = localStorage.getItem(STORAGE_KEYS.AUTH_USER_DETAILS);
        if (storedUserData) {
            const userData = JSON.parse(storedUserData);
            if (userData) {
                setUser(userData);
            }
        }
        setLoading(false);
    }, []);

    const login = (userData) => {
        localStorage.setItem(STORAGE_KEYS.AUTH_USER_DETAILS, JSON.stringify(userData));
        localStorage.removeItem(STORAGE_KEYS.ANONYMOUS_USER_ID);
        setUser(userData);
    };

    const logout = () => {
        // Clear all storage, cookies, and Google session data
        clearAllStorage();
        
        // Logout from Google OAuth
        try {
            googleLogout();
        } catch (error) {
            console.error("Google logout error:", error);
        }

        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}